<template>
  <div class="absolute h-full">
    <div v-if="isShowBackdrop" class="left-268 fixed top-0 z-10 w-full h-full" @click="close" />
    <div class="h-full w-268 flex flex-col" :class="[
      sidebarClasses, {'border-r bg-primary': isHeadquarters && isProjectInstructionsAccepted},
      projectInstructionsActiveFirstStep ? 'border-3 border-link-color rounded-8 relative z-9999': borderColor,
      { 'bg-white': projectInstructionsActiveFirstStep && !isDarkMode}
    ]"
    >
      <LogoModule class="flex flex-shrink-0 text-24 tracking-negative mb-10 md:mb-0 pl-25 pt-18 md:pl-30" />

      <div v-if="isHeadquarters" class="flex mt-50">
        <div class="flex mx-auto">
          <img v-if="teamLogo" class="rounded-6 max-w-100 max-h-80 w-full h-full object-contain" :src="teamLogo" alt="image">

          <label
            v-if="isAdmin && !teamLogo"
            class="w-125 h-115 rounded-14 mx-auto border-3 border-dashed border-grey-700 flex opacity-90 hover:opacity-100 cursor-pointer"
            :class="isDarkMode ? 'bg-book': 'bg-grey-200'"
          >
            <p class="text-15 text-grey-700 m-auto">Upload logo</p>
            <input type="file" class="hidden" @change="uploadLogo">
          </label>
        </div>
      </div>

      <div class="flex-1 overflow-hidden">
        <Projects v-if="isBookPage" />
        <DropdownTeamsPersonal v-if="showTeamDropdown" />
      </div>

      <div class="flex-shrink-0">
        <div class="py-10">
          <!-- upgrade to pro -->
          <div
            v-if="isFreePlan"
            class="flex items-center mb-3 pl-20 md:pl-25 cursor-pointer h-30"
            @click="upgradeToPro"
          >
            <img :src="require(`@/assets/images/thunder.svg`)" alt="" class="w-16 h-16 mx-5">

            <ButtonModule
              text="Upgrade to Pro"
              class="font-semibold text-15"
              :class="isMagenta ? 'text-dark-600' : 'text-app-color'"
            />
          </div>
          <!-- inbox -->
          <div
            v-if="false"
            class="flex items-center justify-between pr-25 pl-20 md:pl-25 cursor-pointer text-15"
            @click="goToInbox"
          >
            <ButtonModule
              text="Inbox"
              prefix="icon-inbox text-20"
              class="text-app-color text-left"
            />

            <!-- B A D G E -->
            <ButtonModule
              text="4"
              class="text-12 w-20 h-20 text-grey-800 bg-grey-main rounded-full justify-center"
            />
          </div>
          <!-- task board -->
          <ButtonModule
            prefix="icon-task-board text-20 mr-7"
            :icon-has-margin="false"
            text="Task board"
            class="px-10 ml-15 md:ml-20 py-6 rounded-6 anim-color-200 text-15"
            :class="[
              isMagenta ? 'text-dark-600' : 'text-app-color',
              taskBoardBtnClasses
            ]"
            @click="goToTaskBoard"
          />

          <!-- weeek planner -->
          <ProOnly :method="openWeekPlannerPopup" :class="{'cursor-pointer': isFreePlan}">
            <ButtonModule
              prefix="icon-calendar text-20 mr-7"
              :icon-has-margin="false"
              :disabled="isFreePlan"
              text="Week Planner"
              class="px-10 ml-15 md:ml-20 py-6 rounded-6 anim-color-200 text-15"
              :class="[
                isMagenta ? 'text-dark-600' : 'text-app-color',
                weekPlannerBtnClasses
              ]"
              @click="goToWeekPlanner"
            />
          </ProOnly>
          <!-- settings -->
          <div :class="[{'border-t my-7 h-1': isBookPage}, borderColor]" />

          <div class="flex items-center justify-between pr-20 ml-15 md:ml-20">
            <ButtonModule
              text="Settings"
              prefix="icon-settings text-20"
              class="text-left px-10 py-6 rounded-6 anim-color-200 text-15"
              :class="[isMagenta ? 'text-dark-600' : 'text-app-color', isDarkMode ? 'hover:bg-dark-500' : 'hover:bg-menu-hover',]"
              @click="openSettingsModal"
            />

            <!-- T H E M E  M O D E  I C O N -->
            <ButtonModule
              has-hover
              :prefix="isDarkMode ? 'icon-sun text-app-color' : 'icon-moon'"
              class="text-21"
              :class="isMagenta ? 'text-dark-600' : 'text-app-color'"
              button-opacity="25"
              @click.stop="updateDesign"
            />
          </div>
        </div>

        <!-- <div v-if="isBookPage" class="w-full px-16 py-10">
          <ButtonModule
            :has-hover="true"
            text="Back to spaces"
            prefix="icon-arrow-left"
            class="text-15"
            :class="isDraculaTheme ? 'text-link-color' : isDarkMode ? 'text-app-color' : 'text-dark-500'"
            @click="backToBooks"
          />
        </div> -->
      </div>
    </div>
    <WeekPlannerPopup ref="weekPlannerPopupRef" />
    <SettingsModal />
  </div>
</template>

<script>
import LogoModule from '@/components/shared/LogoModule'
import ProOnly from '@/components/shared/ProOnly'
import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import SettingsModal from '@/components/settings/SettingsModal'
// import HeadquartersSidebar from '@/components/layout/HeadquartersSidebar'
import Projects from '@/components/projects/Projects'
import { settingsService, teamsService } from '@/services'

import { mapGetters, mapMutations, mapState } from 'vuex'
import localStorageService from '@/core/local-storage'
import { updatePreviousThemesLocalStorage, dispatchChangingDesign } from '@/core/helper-functions'
import DropdownTeamsPersonal from '@/components/shared/DropdownTeamsPersonal.vue'
import WeekPlannerPopup from '@/components/week-planner/WeekPlannerPopup.vue'

export default {
  name: 'HomeSidebar',

  components: { LogoModule, ButtonModule, SettingsModal, Projects, DropdownTeamsPersonal, ProOnly, WeekPlannerPopup },

  props: {
    isShowBackdrop: {
      type: Boolean,
      default: false
    },
    isPoseidonTheme: {
      type: Boolean
    },
    isPaperShape: {
      type: Boolean
    }
  },

  computed: {
    ...mapGetters(['isMobile', 'isFreePlan', 'isDarkMode', 'hasTeam', 'isTeamAccount', 'isMagenta', 'isAdmin']),

    ...mapState({
      settings: state => state.settings.settings,
      previousTheme: state => state.settings.previousTheme,
      isProjectInstructionsAccepted: state => state.profile.user.profile.showProjectOnboarding,
      projectInstructionsActiveStep: state => state.profile.activeStep,
      book: state => state.book.book,
      books: state => state.book.books,
      user: state => state.profile.user,
      team: state => state.team.team,
      headquarters: state => state.team.headquarters,
      previousDarkTheme: state => state.settings.previousDarkTheme,
      isDraculaTheme: state => state.settings.settings.theme === 'Dracula'
    }),

    projectInstructionsActiveFirstStep () {
      return !this.isProjectInstructionsAccepted && this.projectInstructionsActiveStep === 1 && this.isBookPage
    },

    teamLogo () {
      return this.team?.teamLogo?.url
    },

    showTeamDropdown () {
      return this.hasTeam && this.user?.profile.hasPersonal && this.isBooksPage
    },

    isBooksPage () {
      return this.$route.name === 'Books' || this.$route.name === 'TeamBooks'
    },

    isTaskBoard () {
      return this.$route.name === 'TaskBoard' || this.$route.name === 'TaskBoardTeam'
    },

    isWeekPlanner () {
      return this.$route.name === 'WeekPlanner' || this.$route.name === 'WeekPlannerTeam'
    },

    isBookPage () {
      return this.$route.name === 'Book' ||
      this.$route.name === 'TeamBook' ||
      this.isWeekPlanner ||
      this.isTaskBoard ||
      this.isHeadquarters
    },

    sidebarClasses () {
      let classes

      if (this.isProjectInstructionsAccepted) {
        if (this.isHeadquarters || ((this.isTaskBoard || this.isWeekPlanner) && !this.book)) return 'bg-primary'

        if (this.isPoseidonTheme) {
          classes = `${this.isBookPage && (!this.isWeekPlanner || this.IsTaskBoard) ? 'bg-primary' : 'bg-transparent'}`
        } else {
          classes = `${!this.isBookPage ? 'md:bg-primary' : ''} bg-book`
        }
      }

      return classes
    },

    weekPlannerBtnClasses () {
      const prefix = this.isWeekPlanner ? 'font-semibold ' : 'hover:'
      return this.isDarkMode ? `${prefix}bg-dark-500` : `${prefix}bg-menu-hover`
    },

    taskBoardBtnClasses () {
      const prefix = this.isTaskBoard ? 'font-semibold ' : 'hover:'
      return this.isDarkMode ? `${prefix}bg-dark-500` : `${prefix}bg-menu-hover`
    },

    isHeadquarters () {
      return this.$route.name === 'Headquarters'
    },

    borderColor () {
      return this.isDarkMode ? 'border-hover' : 'border-grey-500'
    }
  },

  methods: {
    ...mapMutations([
      'changeActiveState',
      'toggleSettingsModal',
      'toggleAside',
      'updateSidebar',
      'updatePreviousTheme',
      'updateSettings',
      'updatePreviousDarkTheme',
      'setLogo'
    ]),

    backToBooks () {
      localStorageService.removeItem('lastOpenedProject')

      this.isTeamAccount ? this.$router.push({ name: 'TeamBooks', params: { team: this.team.link } }) : this.$router.push({ name: 'Books' })

      if (this.isMobile) {
        this.updateSidebar(false)
      }
    },

    goToInbox () {
      this.$router.push({ name: 'Inbox' })
    },

    goToWeekPlanner () {
      if (this.book?.id) {
        if (this.isTeamAccount) {
          this.$router.push({ name: 'WeekPlannerTeam', params: { team: this.team.link }, query: { spaces: this.book.id } })
        } else {
          this.$router.push({ name: 'WeekPlanner', query: { spaces: this.book.id } })
        }
      } else {
        let bookIds = this.books.filter(b => !b.isSection).map(b => b.id).join(',')
        if (this.isTeamAccount) {
          bookIds += `,${this.headquarters.id}`
          this.$router.push({ name: 'WeekPlannerTeam', params: { team: this.team.link }, query: { spaces: bookIds } })
        } else {
          this.$router.push({ name: 'WeekPlanner', query: { spaces: bookIds } })
        }
      }
      this.updateSidebar(false)
    },

    goToTaskBoard () {
      if (this.book?.id) {
        if (this.isTeamAccount) {
          this.$router.push({ name: 'TaskBoardTeam', params: { team: this.team.link }, query: { spaces: this.book.id } })
        } else {
          this.$router.push({ name: 'TaskBoard', query: { spaces: this.book.id } })
        }
      } else {
        let bookIds = this.books.filter(b => !b.isSection).map(b => b.id).join(',')
        if (this.isTeamAccount) {
          bookIds += `,${this.headquarters.id}`
          this.$router.push({ name: 'TaskBoardTeam', params: { team: this.team.link }, query: { spaces: bookIds } })
        } else {
          this.$router.push({ name: 'TaskBoard', query: { spaces: bookIds } })
        }
      }
    },

    openSettingsModal () {
      this.toggleSettingsModal(true)
    },

    upgradeToPro () {
      if (this.user) {
        window.open(`https://helloivy.co/upgrade?userId=${this.user.id}`, '_blank')
      }
    },

    openWeekPlannerPopup () {
      if (this.isFreePlan) {
        this.$refs.weekPlannerPopupRef.open()
      }
    },

    close () {
      if (this.isMobile) this.updateSidebar(false)
    },

    updateDesign () {
      let theme = ''
      const previousThemes = localStorageService.getItem('previous-themes') || {}
      const userPreviousThemes = previousThemes[this.user?.id] || {}

      if ((!this.settings.theme.includes('Dark')) && (this.settings.theme !== 'Dracula')) {
        theme = this.previousDarkTheme || userPreviousThemes?.dark || 'Dark Orange'
        this.updatePreviousTheme(this.settings.theme)
        updatePreviousThemesLocalStorage(this.user, 'light', this.settings.theme)
      } else {
        theme = this.previousTheme || userPreviousThemes?.light || 'Magenta'
        this.updatePreviousDarkTheme(this.settings.theme)
        updatePreviousThemesLocalStorage(this.user, 'dark', this.settings.theme)
      }

      const settings = { ...this.settings, theme: theme }

      this.updateSettings(settings)
      settingsService.update(settings)
      dispatchChangingDesign(settings)
    },

    uploadLogo (event) {
      const hasFiles = event.target.files.length

      if (!hasFiles) return

      const files = Array
        .from(event.target.files)
        .filter(file => (/image/i).test(file.type))

      if (files.length === 0) return

      const formData = new FormData()
      formData.append('data', files[0])

      return teamsService.upload(formData)
        .then(res => {
          this.setLogo(res.data)
        })
    }
  }
}
</script>
